
const checkoutSuccess = {
    portugues: {
        text1: 'Parabéns!',
        text2: '<b>Agora você faz parte do melhor clube da internet</b>',
        text3: 'sua assinatura foi concluída com sucesso.',
        text4: 'Seu acesso já está liberado! Aproveite!',
        text5: 'Para maior discrição, este débito aparecerá na fatura do seu cartão de crédito como BDS.',
        text6: 'Plano adquirido:',
        text7: 'Verifique os detalhes de sua assinatura no menu',
        text8: 'Minha Conta',
        text9: 'Obrigado',
        text10: 'sua aquisição de créditos foi concluída com sucesso.',        
        text11: 'Meus Créditos',
        text12: 'Verifique os detalhes de sua aquisição no menu',
    },
    ingles: {
        text1: 'Congratulations!',
        text2: '<b>Now you are part of the web best club!</b>',
        text3: 'your subscription is now confirmed.',
        text4: 'You now have full access to our content. Enjoy it!',
        text5: 'For better discretion, this debit is shown in your credit card invoice as BDS.',
        text6: 'Plan:',
        text7: 'Your membership details can be accessed in the option',
        text8: 'My Account',
        text9: 'Thank you',        
        text10: 'your credit purchase has been completed successfully.',        
        text11: 'My Credits',        
        text12: 'Your purchase details can be accessed in the option',                
    }
  }
  
  export default checkoutSuccess
  